import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\BatchOperation\GetBatchOperationRunController::__invoke
* @see app/Http/Controllers/BatchOperation/GetBatchOperationRunController.php
* @route '/api/batch-operations/runs/{run}'
*/
const GetBatchOperationRunController = (args: { run: string | number | { id: string | number } } | [run: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetBatchOperationRunController.url(args, options),
    method: 'get',
})

GetBatchOperationRunController.definition = {
    methods: ["get","head"],
    url: '/api/batch-operations/runs/{run}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\BatchOperation\GetBatchOperationRunController::__invoke
* @see app/Http/Controllers/BatchOperation/GetBatchOperationRunController.php
* @route '/api/batch-operations/runs/{run}'
*/
GetBatchOperationRunController.url = (args: { run: string | number | { id: string | number } } | [run: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { run: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { run: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            run: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        run: typeof args.run === 'object'
        ? args.run.id
        : args.run,
    }

    return GetBatchOperationRunController.definition.url
            .replace('{run}', parsedArgs.run.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\BatchOperation\GetBatchOperationRunController::__invoke
* @see app/Http/Controllers/BatchOperation/GetBatchOperationRunController.php
* @route '/api/batch-operations/runs/{run}'
*/
GetBatchOperationRunController.get = (args: { run: string | number | { id: string | number } } | [run: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetBatchOperationRunController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\BatchOperation\GetBatchOperationRunController::__invoke
* @see app/Http/Controllers/BatchOperation/GetBatchOperationRunController.php
* @route '/api/batch-operations/runs/{run}'
*/
GetBatchOperationRunController.head = (args: { run: string | number | { id: string | number } } | [run: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetBatchOperationRunController.url(args, options),
    method: 'head',
})

export default GetBatchOperationRunController